import React from 'react'
import OpenModal from "./openmodal";

export const HamMenuBtn = () => {
    return (
        <OpenModal btnType="btn-link ham-menu-btn common-color" modalName={"MENU_MODAL"}>
            <i className="fas fa-bars"></i>
        </OpenModal>
    )
}
